module.exports = __webpack_public_path__ + "files/72bb2891fc75f519bacd195d157890c5.png";